<template>
  <v-container fill-height fluid pa-0>
    <v-row justify="center" no-gutters>
      <v-col cols="6">
        <page-heading :text="$t('errors.general.title')" text-center></page-heading>
        <div class="text-center mb-5 mt-5">
          {{$t('errors.general.description')}}
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import PageHeading from "../framework/PageHeading";
  export default {
    name: "MeasureEmpty",
    components:{
      PageHeading
    }
  }
</script>

<style scoped>

</style>